module.exports = __webpack_public_path__ + "media/images/riders/LINDA_INDERGAND-0a4b055a36474a5454cc66192d7b8d6c.png";